<template>
	<div class="voice-price">
		<img
			:src="bitsIcon"
			alt="bits"
			class="voice-price__bits"
		/>
		<span class="body-xs">
			{{ props.price }}
		</span>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import bits099 from '../../../assets/bits_0-99.png';
import bits1k4999 from '../../../assets/bits_1k-4999.png';
import bits5k9999 from '../../../assets/bits_5k-9999.png';
import bits10k from '../../../assets/bits_10k.png';
import bits100999 from '../../../assets/bits_100-999.png';

const props = defineProps<{
	price: number;
}>();

const bitsIcon = computed(() => {
	const price = props.price;

	const priceRanges = [
		{ min: 0, max: 99, icon: bits099 },
		{ min: 100, max: 999, icon: bits100999 },
		{ min: 1000, max: 4999, icon: bits1k4999 },
		{ min: 5000, max: 9999, icon: bits5k9999 },
		{ min: 10000, max: Infinity, icon: bits10k },
	];

	const matchingRange = priceRanges.find(
		(range) => price >= range.min && price <= range.max,
	);

	return matchingRange?.icon ?? bits100999;
});
</script>

<style lang="scss" scoped>
.voice-price {
	display: flex;
	gap: 2px;
	align-items: center;
	justify-content: center;

	height: 20px;
	padding: 0 4px;

	background: var(--hy-color-surface-neutral-soft);
	border-radius: var(--hy-radius-2xs);

	img {
		width: 13px;
		height: 16px;
	}
}
</style>
